import { useMemo } from 'react'
import {
  AD_DESCRIPTION,
  AD_HEADLINE,
  AD_TEXT,
  CALL_TO_ACTION,
  CAROUSEL_ITEMS,
  CLICK_THROUGH_LINK,
  DESCRIPTION_OPTION,
  DESCRIPTIONS_LIST,
  HEADLINE_OPTION,
  HEADLINES_LIST,
  PRIMARY_TEXT_LIST,
  TEXT_OPTION
} from './fields'
import { FILE_URL, MEDIA_TYPE } from '../../ReusableFormFields/AdFileUpload/fields'

// todo remove allowUseSingleMediaItem prop after create ad form refactoring 'use nested singleMediaItem object'
export default function useFlatFormikValues({ formikValues, allowUseSingleMediaItem }) {
  // We support list of headlines and descriptions for custom ad, up to 5 items
  // For NOT custom ad we use 0 element from description and headline list
  const carouselItems = formikValues?.[CAROUSEL_ITEMS]?.map(item => ({
    ...item,
    [AD_HEADLINE]: item[HEADLINES_LIST]?.[0]?.text,
    [AD_DESCRIPTION]: item[DESCRIPTIONS_LIST]?.[0]?.text
  }))

  const flatFormikValues = useMemo(() => {
    // todo remove this condition after create ad form refactoring 'use nested singleMediaItem object'
    if (allowUseSingleMediaItem && formikValues.singleMediaItem) {
      return {
        ...formikValues,
        [AD_TEXT]: formikValues[PRIMARY_TEXT_LIST]?.[0]?.text,
        [AD_HEADLINE]: formikValues.singleMediaItem[HEADLINES_LIST]?.[0]?.text || formikValues[AD_HEADLINE],
        [AD_DESCRIPTION]: formikValues.singleMediaItem[DESCRIPTIONS_LIST]?.[0]?.text || formikValues[AD_DESCRIPTION],
        ...(carouselItems && { [CAROUSEL_ITEMS]: carouselItems }),
        [FILE_URL]: formikValues.singleMediaItem[FILE_URL],
        [MEDIA_TYPE]: formikValues.singleMediaItem[MEDIA_TYPE],
        [TEXT_OPTION]: formikValues[TEXT_OPTION],
        [DESCRIPTION_OPTION]: formikValues.singleMediaItem[DESCRIPTION_OPTION],
        [HEADLINE_OPTION]: formikValues.singleMediaItem[HEADLINE_OPTION],
        [CLICK_THROUGH_LINK]: formikValues.singleMediaItem[CLICK_THROUGH_LINK],
        [CALL_TO_ACTION]: formikValues.singleMediaItem[CALL_TO_ACTION]
      }
    } else {
      // todo remove else statement after create ad form refactoring 'use nested singleMediaItem object'
      return {
        ...formikValues,
        [AD_TEXT]: formikValues[PRIMARY_TEXT_LIST]?.[0]?.text,
        [AD_HEADLINE]: formikValues[HEADLINES_LIST]?.[0]?.text || formikValues[AD_HEADLINE],
        [AD_DESCRIPTION]: formikValues[DESCRIPTIONS_LIST]?.[0]?.text || formikValues[AD_DESCRIPTION],
        ...(carouselItems && { [CAROUSEL_ITEMS]: carouselItems }),
        [FILE_URL]: formikValues[FILE_URL],
        [MEDIA_TYPE]: formikValues[MEDIA_TYPE],
        [TEXT_OPTION]: formikValues[TEXT_OPTION],
        [DESCRIPTION_OPTION]: formikValues[DESCRIPTION_OPTION],
        [HEADLINE_OPTION]: formikValues[HEADLINE_OPTION],
        [CLICK_THROUGH_LINK]: formikValues[CLICK_THROUGH_LINK],
        [CALL_TO_ACTION]: formikValues[CALL_TO_ACTION]
      }
    }
  }, [formikValues, allowUseSingleMediaItem, carouselItems])

  return flatFormikValues
}
